<template>
  <v-row justify="center" class="mt-12">
    <v-col cols="10" sm="8" md="6" lg="4">
      <v-card class="mt-8" shaped>
        <v-card-text>
          <div class="d-flex justify-center mt-8 mb-4">
            <img
              :src="require('../assets/alumni_ucm.png')"
              width="250"
              alt="logo alumni"
            />
          </div>
          <h2 class="text-center my-5">Credencial Alumni UCM</h2>
          <v-alert v-if="error" dense type="error" class="mb-4">{{
            error
          }}</v-alert>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="login()"
            lazy-validation
          >
            <v-text-field
              v-model="rut"
              :rules="rulesRut"
              label="Rut sin guión ni digito verificador"
              required
              placeholder="Ej. 19876543"
            ></v-text-field>

            <v-text-field
              v-model="password"
              type="password"
              :rules="[(v) => !!v || 'campo requerido']"
              label="Contraseña institucional"
              placeholder="Misma que Portal del Estudiante"
              required
            ></v-text-field>

            <p>
              <a href="https://gestion-clave.ucm.cl/" target="_blank"
                >Olvidé mi contraseña</a
              >
            </p>

            <div class="d-flex justify-center">
              <v-btn
                :disabled="!valid"
                color="primary"
                class="mr-4 mt-5"
                type="submit"
              >
                Ingresar
                <v-icon right>mdi-send</v-icon>
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <loading-vue :loading="loading"></loading-vue>
  </v-row>
</template>

<script>
import LoadingVue from "@/components/Loading.vue";

export default {
  name: "Login",
  props: ["urlApi"],
  components: {
    LoadingVue,
  },
  beforeRouteEnter(to, from, next) {
    const token = sessionStorage.getItem("token");
    if (token) {
      next("/credencial");
    } else {
      next();
    }
  },
  data: () => ({
    valid: true,
    rut: "",
    password: "",
    error: "",
    loading: false,
    rulesRut: [
      (v) => !!v || "campo requerido",
      (v) => /^[0-9]+$/.test(v) || "caracter no permitido",
    ],
  }),

  methods: {
    login() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        grecaptcha.ready(() => {
          grecaptcha
            .execute("6LdVqrglAAAAADaSGxoD9WfBoJ04z6m_WclQA0Xv", {
              action: "submit",
            })
            .then((token) => {
              fetch(`${this.urlApi}api/account`, {
                method: "POST",
                body: JSON.stringify({
                  rut: this.rut,
                  password: this.password,
                  recaptcha: token,
                }),
                headers: {
                  "Content-Type": "application/json",
                },
              })
                .then((response) => {
                  if (response.status == 401) {
                    return Promise.reject(null);
                  } else {
                    return response.json();
                  }
                })
                .then((data) => {
                  if (data.msj) {
                    this.error = data.msj;
                    this.loading = false;
                  } else {
                    const estudiante = {
                      rut: this.rut,
                      nombre: data.fullname,
                      correo: data.correo,
                    };
                    sessionStorage.setItem("user", JSON.stringify(estudiante));
                    sessionStorage.setItem("token", data.Token);
                    this.$router.push("/credencial");
                  }
                })
                .catch((err) => {
                  // console.log(err);
                  this.loading = false;
                  this.password = "";
                  this.error =
                    "Usuario o contraseña invalida o no cuenta con permisos para ingresar";
                });
            });
        });
      }
    },
  },
};
</script>
